import { Route } from "react-router-dom";
import ProtectedRoute from "src/routes/middlewares/ProtectedRoute";
import DashboardSettingsView from "src/views/authenticated/settings/SettingsView";

const SettingsRoutes = [
	<Route
		element={
			<ProtectedRoute>
				<DashboardSettingsView />
			</ProtectedRoute>
		}
		path="/settings/notifications"
		key="/settings/notifications"
	/>,
];
export default SettingsRoutes;
